import { RedoShopifyOrderCancelReason } from "@redotech/redo-model/fulfillments/order-cancel-reason";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const OUTSTANDING_FULFILLMENTS_CANCEL_ORDER_ERROR_MESSAGE =
  "Cannot cancel this order because it has outstanding fulfillments.";

export const GENERIC_CANCEL_ORDER_ERROR_MESSAGE =
  "An error occurred while canceling this order. Please try again or contact support.";

export function getUserFacingCancelOrderErrorMessage(message: string): string {
  if (
    /^Shopify orderCancel failed for order .+?: INVALID: orderId - Cannot cancel an order that has outstanding fulfillments$/.test(
      message,
    )
  ) {
    return OUTSTANDING_FULFILLMENTS_CANCEL_ORDER_ERROR_MESSAGE;
  }

  return GENERIC_CANCEL_ORDER_ERROR_MESSAGE;
}

export const cancelFulfillmentGroups = {
  name: "cancelFulfillmentGroups" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(zExt.objectId()),
    reason: createEnum(RedoShopifyOrderCancelReason).nullish(),
    notifyCustomer: z.boolean().nullish(),
    refund: z.boolean().nullish(),
    restock: z.boolean().nullish(),
  }),
  output: z.null(),
};
